import React, { Component } from "react";
import { Container } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  links: {
    textDecoration: "inherit",
    color: "inherit",
  }
});

const TviFooterContainer = withStyles((theme) => ({
  root: {
    color: "#fafafa",
    textAlign: "center",
    padding: "2.2rem",
    display: "flex",
    flexDirection: "column",
  },
}))(Container);

class Footer extends Component {
  render = () => {
    const { classes } = this.props;
    return (
      <div style={{ backgroundColor: "#231f1f", marginTop: "1.7rem"}}>
        <TviFooterContainer>
          <span style={{ lineHeight: "1.6" }}>
            Trade View is an Authorised Representative of Trade View Investments who holds an Australian Financial Services License (AFSL) No. 510116 to carry on a financial services business in Australia, limited to its financial services covered by its AFSL. Trade View Pty Ltd. ABN 5163 3500 115 Authorised Representative No. 1279493 | All Rights Reserved. Powered by Trade View Investments.
          </span>
          <span style={{ lineHeight: "1.6", padding: "0.8rem 0" }}>
            Risk Warning: Trading leveraged products carries significant risks and is not suitable for all investors. Please ensure that you fully understand the risks involved before entering into any trades. You could lose substantially more than your initial deposit. Any information on this website is general in nature and does not take into account your financial situation, objectives or your needs. Hypothetical or Simulated performance results have certain limitations, unlike an actual performance record. Simulated results DO NOT represent actual trading. Also, since trades have not been executed the results may have under-or-over compensated for impact, if any, of certain market factors, such as lack of liquidity. Simulated Trading programs in general are also subject to the fact that they are designed with the benefit of hindsight. No representation is being made that any account will or is likely to achieve profit or loss similar to those shown.
          </span>

          <span style={{ lineHeight: "1.7"}}>
            <a className={classes.links} href="https://www.tradeview.com.au/legal-documents/terms/" rel="noopener noreferrer" target="_blank">Terms &amp; Conditions</a> /&nbsp;
            <a className={classes.links} href="https://www.tradeview.com.au/legal-documents/financial-services-guide/?_ga=2.48249632.76545703.1594447372-1219221867.1590384949" rel="noopener noreferrer" target="_blank">Financial Services Guide</a> /&nbsp;
            <a className={classes.links} href="https://www.tradeview.com.au/legal-documents/privacy-policy/" rel="noopener noreferrer" target="_blank">Privacy Policy</a> /&nbsp;
            <a className={classes.links} href="https://www.tradeview.com.au/legal-documents/disclaimer/" rel="noopener noreferrer" target="_blank">Disclaimer</a>
          </span>

        </TviFooterContainer>
      </div>
    );
  };
}

export default withStyles(styles)(Footer);

